import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const situations = [
  {
    emoji: "😟",
    question: "Confused about what to do after 12th?",
    answer: "Take our 2-minute quiz — we'll map your best options",
  },
  {
    emoji: "💸",
    question: "Need a job urgently but no experience?",
    answer: "Free government programs offer training and placement assistance",
  },
  {
    emoji: "🎓",
    question: "Can't afford expensive courses?",
    answer: "We list free programs curated from official government and global sources",
  },
  {
    emoji: "💰",
    question: "Want to earn while learning?",
    answer: "NAPS gives ₹5,000–₹9,000/month stipend during training",
  },
];

export const UserSituationSection = () => {
  return (
    <section className="py-12 md:py-16 bg-accent/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center mb-8"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            Does This Sound Like You?
          </h2>
          <p className="text-muted-foreground">
            You're not alone — thousands of students face the same questions
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
          {situations.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.08 }}
              className="p-5 rounded-2xl bg-card border border-border hover:shadow-card transition-all"
            >
              <span className="text-3xl block mb-2">{item.emoji}</span>
              <p className="font-semibold text-foreground mb-1">{item.question}</p>
              <p className="text-sm text-muted-foreground">{item.answer}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Button asChild variant="hero" size="lg">
            <Link to="/career-quiz">
              Find My Answer <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};
